export interface IAppWillMountHandler {
	appWillMount: () => Promise<void> | void
}

export interface IAppWillLoadPageHandler {
	appWillLoadPage: (pageInfo: { pageId: string; contextId: string }) => Promise<void> | void
}

export interface IAppDidLoadPageHandler {
	appDidLoadPage: (pageInfo: { pageId: string; contextId: string }) => Promise<void> | void
}

export interface IPageWillMountHandler {
	pageWillMount: (pageId: string) => Promise<void> | void
}

export interface IPageWillUnmountHandler {
	pageWillUnmount: (pageInfo: { pageId: string; contextId: string }) => Promise<void> | void
}

type IPageDidMountHandlerResult = IPageDidUnmountHandler['pageDidUnmount']
export interface IPageDidMountHandler {
	pageDidMount: (
		pageId: string,
		page: HTMLElement
	) => IPageDidMountHandlerResult | Promise<IPageDidMountHandlerResult> | void | Promise<void>
}

export interface IPageDidUnmountHandler {
	pageDidUnmount: () => void
}

export interface IAppDidMountHandler {
	appDidMount: (target: HTMLElement) => void
}

export const LifeCycle = {
	AppWillMountHandler: Symbol('AppWillMountHandler'),
	AppWillLoadPageHandler: Symbol('AppWillLoadPageHandler'),
	AppDidLoadPageHandler: Symbol('AppDidLoadPageHandler'),
	PageWillMountHandler: Symbol('PageWillMountHandler'),
	PageDidMountHandler: Symbol('PageDidMountHandler'),
	PageWillUnmountHandler: Symbol('PageWillUnmountHandler'),
	PageDidUnmountHandler: Symbol('PageDidUnmountHandler'),
	AppDidMountHandler: Symbol('AppDidMountHandler'),
}
